<template>
  <b-modal
    id="appraisal-modal-confirm"
    v-model="active"
    data-cy="appraisal-modal-confirm"
    :destroy-on-hide="false"
    aria-role="dialog"
    aria-label="Procesar Valorización"
    has-modal-card
    trap-focus
    :on-cancel="close"
    aria-modal>
    <div class="modal-card" style="width: auto">
      <header class="modal-card-body">
        <div class="modal-card-title modal-title">
          Atención
        </div>
        <a
          class="close-modal delete"
          type="button"
          @click="close()" />
      </header>
      <section class="modal-card-body">
        <p>
          Se procesará la valorización con los siguientes datos:
        </p>
        <p>
          <strong>Comprador: </strong> {{ appraisal.investorName }} ({{ appraisal.investorId }}) <br>
          <strong>Tipo: </strong>{{ appraisal.salesType }} <br>
          <strong>Fecha de venta: </strong>{{ appraisal.salesDate }} <br>
          <strong>Operaciones: </strong>{{ appraisal.totalOperations }} <br>
          <strong>Total monto otorgado (UF): </strong>{{ appraisal.totalAmountAwarded }}
        </p>
        <p class="text-align-center">
          ¿Estás seguro que deseas continuar?
        </p>
        <div class="buttons is-pulled-right">
          <b-button
            id="appraisal-modal-button-no"
            data-cy="appraisal-modal-button-no"
            class="button is-button-secondary"
            label="No"
            rounded
            @click="close()" />
          <b-button
            id="appraisal-modal-button-continuar"
            data-cy="appraisal-modal-button-continuar"
            label="Continuar"
            rounded
            class="button is-button-primary"
            @click="confirm()" />
        </div>
      </section>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    appraisal: {
      type: Object,
      required: true
    },
    isComponentModalActive: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {

    };
  },
  computed: {
    active() {
      return this.$props.isComponentModalActive;
    }
  },
  methods: {
    confirm() {
      this.$emit('process');
    },
    close() {
      this.$emit('cancelProcess');
    }
  }
};
</script>

<style scoped>
.modal-card-body p {
  padding-bottom: 1rem;
}
.pad-right {
  margin-right: 1rem;
}
.modal-card-body {
  position: relative;
}
.modal-card-body .close-modal {
  position: absolute;
  right: 20px;
  top:20px;
  width: 40px;
}
.modal-title {
  color: #00CCD1;
  font-weight:500;
}
</style>
